import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { FormActions } from "../utils/FormActions";
import { PlayerMetadataFields } from "./PlayerMetadataFields";
export const PlayerForm = ({ onSubmit, player, onCancel, submitLabel, cancelLabel, isSubmitting, }) => {
    const { control, handleSubmit } = useForm({
        defaultValues: {
            nationality: player?.nationality || "US",
            heading: player?.heading || 50,
            passing: player?.passing || 50,
            defending: player?.defending || 50,
            positioning: player?.positioning || 50,
            finishing: player?.finishing || 50,
            speed: player?.speed || 50,
            fitness: player?.fitness || 50,
            keeping: player?.keeping || 50,
            dribbling: player?.dribbling || 50,
            shooting: player?.shooting || 50,
            tackling: player?.tackling || 50,
            crossing: player?.crossing || 50,
            leadership: player?.leadership || 50,
            communication: player?.communication || 50,
            bio: player?.bio ?? "",
            foot: player?.foot || "Right",
            positionOne: player?.positionOne ?? "GK",
            positionTwo: player?.positionTwo ?? "",
        },
    });
    return (_jsxs(Box, { component: "form", role: "form", onSubmit: handleSubmit((data) => {
            onSubmit(data);
        }), noValidate: true, sx: { mt: 1 }, children: [_jsx(PlayerMetadataFields, { control: control }), _jsx(FormActions, { submitLabel: submitLabel ?? (player === undefined ? "Create" : "Update"), onCancel: onCancel, cancelLabel: cancelLabel, isSubmitting: isSubmitting })] }));
};
